import $ from 'jquery'

export const Search = (() => {
  'use strict'

  let $toggleBtn,
			$searchDropdown,
			$searchInput;

  function init() {

		$toggleBtn = $('#toggle-search');
		$searchDropdown = $('#search-dropdown');
		$searchInput = $('#search-dropdown .search-field');

    events();
  }

  function events() {
    $toggleBtn.click(function(){

			if ($searchDropdown.hasClass('show')) {
				hideSearchform();
			} else {
				showSearchform();
			}
		});

		// close search dropdown when clicking outside of it
		$('body').click(function(evt){

			if(evt.target.id == "search-dropdown" || evt.target.id == "toggle-search")
				return;

			if($(evt.target).closest('#search-dropdown').length)
				return;

			hideSearchform();
		});
  }

	function showSearchform(){
		$searchDropdown.addClass('show');
		$searchInput.focus();
		$toggleBtn.addClass('show-close-msg').text('CLOSE');
	}

	function hideSearchform(){
		$searchDropdown.removeClass('show');
		$toggleBtn.removeClass('show-close-msg').text('SEARCH');
	}

  return { init }
})()
